import React from 'react';
import { Container, Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/PageTitle/PageTitle';

export function ContactsModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('Contacts')} />
      <Container>
        <Panel spacing={0}>
          <div>{t('Contacts content coming soon')}</div>
        </Panel>
      </Container>
    </>
  );
}
